var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewTab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 22,
    viewBox: "0 0 23 22",
    width: 23,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m4.77555 6.36359c-.24898 0-.49147.10093-.67309.28655-.18221.18624-.28768.44255-.28768.71345v10.00001c0 .2709.10547.5272.28768.7135.18162.1856.42411.2865.67309.2865h9.78425c.249 0 .4914-.1009.6731-.2865.1822-.1863.2876-.4426.2876-.7135v-5.4545c0-.4519.3663-.8182.8182-.8182s.8182.3663.8182.8182v5.4545c0 .6935-.2694 1.3622-.7544 1.8579-.4856.4963-1.1481.7785-1.8427.7785h-9.78425c-.69464 0-1.35712-.2822-1.84274-.7785-.48502-.4957-.7544-1.1644-.7544-1.8579v-10.00001c0-.69352.26938-1.36213.7544-1.85785.48562-.49633 1.1481-.77852 1.84274-.77852h5.33685c.4519 0 .8182.36631.8182.81819 0 .45187-.3663.81818-.8182.81818z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.6704 2c-.4519 0-.8182.36632-.8182.81819s.3663.81819.8182.81819h3.3916l-8.42387 8.60962c-.31602.323-.31037.841.01262 1.157.32299.3161.84101.3104 1.15703-.0126l8.38132-8.56614v3.44849c0 .45188.3663.81819.8182.81819.4518 0 .8182-.36631.8182-.81819v-5.45456c0-.15427-.0427-.29857-.117-.42172-.012-.02004-.0249-.03951-.0386-.05837-.0516-.07109-.1144-.13356-.1857-.18482-.1343-.09647-.299-.15328-.4769-.15328z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTab);
export default __webpack_public_path__ + "static/media/new-tab.e32c32f95d2caf05b0c091d4cbcdb4a0.svg";
export { ForwardRef as ReactComponent };